import { BasketItem, ShippingMethod } from '@/modules/checkout/api';
import { getCheapestShippingMethod } from '@/shared/utils/get-cheapest-shipping-method';
import { getLargestShippingGroupByBasketItems } from '@/shared/utils/get-largest-shipping-group-by-basket-items';
import { getShippingMethodsByShippingGroup } from '@/shared/utils/get-shipping-methods-by-shipping-group';
import { formatPrice } from 'utils';
import { useTranslation } from '@/i18n/client';

export function ShippingPrice({
  basketItems,
  basketShippingPrice,
  basketLocale,
  shippingMethods,
  hasShippingMethodSelected,
  hasFreeShipping,
}: {
  basketItems: BasketItem[];
  basketShippingPrice: { amount: number; currency: string };
  basketLocale: string;
  shippingMethods: ShippingMethod[];
  hasShippingMethodSelected: boolean;
  hasFreeShipping: boolean;
}) {
  const { t } = useTranslation(['common']);

  const largestShippingGroup =
    getLargestShippingGroupByBasketItems(basketItems);

  const availableShippingMethods = getShippingMethodsByShippingGroup(
    largestShippingGroup,
    shippingMethods
  );

  const cheapestShippingMethod = getCheapestShippingMethod(
    availableShippingMethods
  );

  let shippingPrice;

  if (hasShippingMethodSelected && basketShippingPrice.amount) {
    // Shipping selected by user in checkout/cart
    shippingPrice = formatPrice(
      basketShippingPrice.amount,
      basketLocale,
      basketShippingPrice.currency
    );
  } else if (cheapestShippingMethod) {
    // Shipping not selected, show default (the cheapest)
    shippingPrice = t('common:common.priceFrom', {
      price: formatPrice(
        cheapestShippingMethod.price.amount,
        cheapestShippingMethod.locale,
        cheapestShippingMethod.price.currency
      ),
    });
  }

  if (hasFreeShipping && cheapestShippingMethod) {
    shippingPrice = t('common:common.priceFrom', {
      price: formatPrice(
        0,
        cheapestShippingMethod.locale,
        cheapestShippingMethod.price.currency
      ),
    });
  }

  return <>{shippingPrice}</>;
}
